import { Lightning } from "@lightningjs/sdk";
import { MaterialIcon } from "../MaterialIcon/MaterialIcon";
import theme from "../../../lib/theme";
import { Theme, themeManager } from "../../configurations/Theme/ThemeManager";
interface IconTemplateSpec extends Lightning.Component.TemplateSpec {
    hasActive: boolean;
    iconWidth: number;
    iconHeight: number;
    colorValue: string;
    activeColorValue: string;
    icon: string;
    Icon: any;
    // ActiveIcon: IconProps;
}

export class Icon
    extends Lightning.Component<IconTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<IconTemplateSpec>
{
    private _themeCallback!: (theme: Theme | undefined) => void;

    _color: string = theme.colors.text.primary;
    _activeColor: string = theme.colors.text.accentFocus;

    _hasActive = true;
    _iconSize = 24;
    _iconHeight = 24;
    _icon: string | undefined;

    static override _template(): Lightning.Component.Template<IconTemplateSpec> {
        return {
            collision: true,
            zIndex: 20,
            // mount: 0.5,
            Icon: {
                y: (h) => h / 2,
                type: MaterialIcon,
                // x: this._bgSizeW / 2 - this._iconSize / 2,
                // y: this._bgSizeH / 2,
                mount: 0.5
                // h: this._iconSize,
                // w: this._iconSize
            }
            // ActiveIcon: {
            //     alpha: 0.01
            // }
        };
    }

    override _init() {
        this._themeCallback = this._onThemeChange.bind(this);
        themeManager.subscribe(this._themeCallback);
    }

    override _detach() {
        themeManager.unsubscribe(this._themeCallback);
    }

    private _toHex(value: string | number | undefined): string | undefined {
        if (typeof value === "string" || value === undefined) {
            return value;
        }
        return `#${(value >>> 0).toString(16).padStart(6, "0").slice(-6)}`;
    }
    private _onThemeChange(customTheme: Theme | undefined): void {
        this._color = this._toHex(customTheme?.title) ?? theme.colors.text.primary;
        this._activeColor = this._toHex(customTheme?.interaction) ?? theme.colors.text.accent;

        this.patch({
            Icon: {
                colorValue: this.hasFocus() ? this._activeColor : this._color
            }
        });
    }

    set hasActive(value: boolean) {
        this._hasActive = value;
    }

    set icon(value: string) {
        this._icon = value;
        this._updateIcon();
    }

    set colorValue(value: string) {
        this._color = value;

        this._updateIcon();
    }

    set activeColorValue(value: string) {
        this._activeColor = value;
    }

    set iconWidth(value: number) {
        this._iconSize = value;
        this._iconHeight = value;
        this._updateIcon();
    }

    set iconHeight(value: number) {
        this._iconHeight = value;
        this._updateIcon();
    }

    override _focus() {
        if (!this._hasActive) return;

        this.patch({
            Icon: {
                colorValue: this._activeColor
            }
        });
    }

    override _unfocus() {
        if (!this._hasActive) return;

        this.patch({
            Icon: {
                colorValue: this._color
            }
        });
    }

    _updateIcon() {
        if (!this._icon) return;
        this.patch({
            Icon: {
                w: this._iconSize,
                h: this._iconSize,
                icon: this._icon,
                colorValue: this._color
            }
        });
    }

    // _handleClick() {
    //     this.signal("handleClick");
    // }

    _handleHover() {
        this.signal("handleHover");
    }
}
